import "./App.css";
import BackToTop from "./components/BackToTop";
import Home from "./components/Home";
import NavBar from "./components/NavBar";

function App() {
  return (
    <div className="App container-fluid">
      <BackToTop>
        <NavBar />
        <h1>👂🏽 Choose Connection 🗣️</h1>
        <Home />
      </BackToTop>
    </div>
  );
}

export default App;
